<h2 mat-dialog-title>{{ title }}</h2>
<button type="button" class="btn btn-link modal-close" (click)="close()">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M6 6L18 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg></button>

<mat-dialog-content>

  <div class="col-md-12 col-sm-12" *ngIf="!singleItemPreview" style="max-height: 60vh;overflow-y: auto;">
    <div class="col-md-6" style="display: inline;">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <div class="black-text fs-16 font-medium" *ngIf="packageDetails.features!">
          Features: <span class="badge chip-list count noclick">#{{packageDetails.features.length}}</span>
        </div>
      </div>
      <div>

        <ul class="added-view-package" *ngFor="let featureGroup of geFeatureTree(packageDetails.features!) | keyvalue">
          <h3 class="black-text fs-16 font-medium">{{featureGroup.key}} <span
              class="badge chip-list count badge-secondary noclick">#{{featureGroup.value.length}}</span></h3>
          <hr />
          <li class="list toolkit-display" *ngFor="let feature of featureGroup.value">
            <label class="toolkit-display"><span class="toolkit-display-name">{{feature.featureName}}</span></label>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-md-6" style="display: inline;">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <div class="black-text fs-16 font-medium" *ngIf="packageDetails.modules!">
          Modules: <span class="badge chip-list count noclick">#{{packageDetails.modules.length}}</span>
        </div>
      </div>
      <div class="added-view-package">
        <div class="list" *ngFor="let module of packageDetails.modules!">
          {{module.moduleName}}
        </div>
      </div>
    </div>
    <div class="col-md-6" style="display: inline">
      <div style=" margin-top: 1.2em;" class="d-flex align-items-center justify-content-between mb-2">
        <div class="black-text fs-16 font-medium" *ngIf="packageDetails.subCategories!">
          Analytics Toolkits: <span
            class="badge chip-list count noclick">#{{packageDetails.subCategories.length}}</span>
        </div>
      </div>
      <div>

        <ul class="added-view-package"
          *ngFor="let subCategoryGroup of getSubcategoryTree(packageDetails.subCategories!) | keyvalue">
          <h3 class="black-text fs-16 font-medium">{{subCategoryGroup.key}} <span
              class="badge chip-list count badge-secondary noclick">#{{subCategoryGroup.value.length}}</span></h3>
          <hr />
          <li class="list toolkit-display" *ngFor="let subCategory of subCategoryGroup.value">
            @if(subCategory.subCategoryDisplayName!=null){
            <label class="toolkit-display">
              <mat-icon style="vertical-align: text-top;">short_text</mat-icon>
              <span class="toolkit-display-text">{{subCategory.subCategoryDisplayName}}</span>
              <span class="toolkit-display-name">{{subCategory.subCategoryName}}</span>
            </label>

            }
            @else{
            <label class="toolkit-display"><span
                class="toolkit-display-name">{{subCategory.subCategoryName}}</span></label>

            }
          </li>
        </ul>
      </div>
    </div>
    <!--METRICS IS NOT USED-->
    <div Xstyle="display: inline;" style="display: none;">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <div class="black-text fs-16 font-medium" *ngIf="packageDetails.metrics!">
          Metrics: <span class="badge chip-list count noclick">#{{packageDetails.metrics.length}}</span>
        </div>
      </div>
      <div class="added-view-package">
        <div class="list" *ngFor="let metric of packageDetails.metrics!">
          {{metric.metricName}}
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-12 col-sm-12" *ngIf="singleItemPreview" style="max-height: 60vh;overflow-y: auto;">

    <div class="col-md-6" style="display: inline;" *ngFor="let item of itemToPreview | keyvalue">

      <div>
        <ul class="added-view-package">
          <h4 class="black-text fs-16 font-medium" [ngSwitch]="item.key">

            <span class="chip-list count noclick" *ngSwitchCase="'-'">{{item.value.length}}
              @if(item.value.length>1){items}@else{item}</span>
            <span *ngSwitchDefault>{{item.key}} <span class="chip-list count">{{item.value.length}}
                @if(item.value.length>1){items}@else{Item}</span></span>

          </h4>
          <hr />
          <li class="chip-main list" *ngFor="let entry of item.value">
            @if(entry.itemDisplay==null)
            {
            <label class="toolkit-display"><span class="toolkit-display-name">{{entry.itemName}}</span></label>
            }
            @else{
            <label class="toolkit-display">
              <mat-icon style="vertical-align: text-top;">short_text</mat-icon>
              <span class="toolkit-display-text">{{entry.itemDisplay}}</span>
              <span class="toolkit-display-name">{{entry.itemName}}</span>
            </label>
            }

          </li>
        </ul>
      </div>
    </div>

  </div>
</mat-dialog-content>